import React from 'react';
import {Select} from "antd";
import api from "../../api/apiInterceptor";
import {useDispatch, useSelector} from "react-redux";
import {allDevicesSelectData} from "../../redux-store/selectors";
import {displayNotification} from "../../redux-store/notification";

const {Option} = Select

function TableConfigCell({cell, tableId, installationID}) {

    const {options} = useSelector(allDevicesSelectData)

    const dispatch = useDispatch()

    const handleChange = async (e) => {
        let result = await api.put(`/api/installations/${installationID}/tableviews/${tableId}/rows/${cell.rowId}/cells/${cell.id}`, {
            "deviceId": e
        })

        if (result.data) {
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Sačuvana izmjena uređaja",
                title: "Tabele"
            }))
        } else {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: "Greška prilikom izmjene uređaja",
                title: "Tabele"
            }))
        }

    }

    return (
        <>
            <div className={"row"}>
                <Select defaultValue={cell.deviceId} onChange={handleChange}>
                    {options.map((item) => {
                        return (<Option key={item.id} value={item.id}>{item.model}</Option>)
                    })}
                </Select>
            </div>
        </>
    );
}

export default TableConfigCell;